/* eslint-disable no-undef */
/* 回到顶部 */
$.fn.goTop = function (dom) {
  var gotop_icon = 'data:image/png;base64,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';
  var _this = this;
  _this.html('<img src="' + gotop_icon + '">');

  _this.css({
    cursor: "pointer",
    display: "none",
    position: "fixed",
    "z-index": "9999",
    "font-size": "0",
    right: "20px",
    bottom: "15px",
    width: "48px",
  });
  _this.find("img").css({
    width: "100%"
  });
  //var clientHeight = document.documentElement.clientHeight; //获取可视区域的高度
  var height_block = 20; //将高度分成N段
  var thisFn = {
    onScroll: function () {
      //获取滚动条的滚动高度
      var osTop = 0;
      if (dom) {
        osTop = $(dom).scrollTop();
      } else {
        osTop = document.documentElement.scrollTop || document.body.scrollTop;
      }
      var is_show = _this.css("display");
      if (osTop > 0) {
        if (is_show == 'none') {
          _this.fadeIn();
        }
      }
      if (osTop <= 0) {
        _this.fadeOut();
      }
    },
    goTopFn: function () {
      //获取滚动条的滚动高度
      var osTop = 0;
      //用于设置速度差，产生缓动的效果
      var speed = 0;

      if (dom) {
        osTop = $(dom).scrollTop();
        speed = Math.floor(-osTop / height_block);
        $(dom).scrollTop(osTop + speed);
      } else {
        osTop = document.documentElement.scrollTop || document.body.scrollTop;
        speed = Math.floor(-osTop / height_block);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + speed;
      }

      var is_show = _this.css("display");
      if (osTop > 0) {
        if (is_show == 'none') {
          _this.fadeIn();
        }
        setTimeout(function () {
          thisFn.goTopFn();
        }, 1);
      }
    }
  };

  if (dom) {
    $(dom).on('scroll', function () {
      thisFn.onScroll();
    });
  } else {
    window.onscroll = function () {
      thisFn.onScroll();
    };
  }

  //回到顶部按钮点击事件
  _this.off().on("click", function () {
    thisFn.goTopFn();
  });
};